import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import {
  PlantAlarmSystemDTO,
  PlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import plantsClient from '@/core/services/plants';

@Options({
  name: 'PlantAlarmSystem',
  emits: ['add-object', 'add-structure', 'update-list'],
  props: {
    currentPlant: {
      type: Object as PropType<PlantDetailDTO>,
      required: false,
    },
  },
})
export default class PlantAlarmSystem extends Vue {
  currentPlant!: PlantDetailDTO;
  alarmsystem: PlantAlarmSystemDTO | null = null;

  get backLink() {
    return {
      name: 'page-plant-dashboard',
      params: this.$route.params,
    };
  }

  created() {
    this.fetchData();
  }

  async fetchData() {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      this.alarmsystem = await plantsClient.alarmsystem(
        this.currentPlant.desktopId as number
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
